'use client'

import dynamic from 'next/dynamic'

// The retired control card must not join the active treatment's startup
// bundle. Keep SSR when the experiment registry selects this card again.
export const ScorecardClientLazy = dynamic(() => import('./scorecard-client').then((module) => module.ScorecardClient))
